{/* Auto-generated icon - do not edit */}
import React from 'react'

interface VectorIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const VectorIcon = React.forwardRef<SVGSVGElement, VectorIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 161 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M99.7952 38.28C101.166 37.3217 102.244 36.5378 103.353 35.7988C114.545 28.3369 126.628 26.837 139.368 30.7449C154.82 35.4836 161.17 50.7239 159.846 63.0099C158.727 73.4256 153.605 81.8379 146.081 88.8515C143.155 91.5799 139.39 93.0895 135.548 93.862C128.537 95.2712 121.473 96.5399 114.373 97.3544C96.2819 99.4304 78.0777 99.3293 59.9043 99.6207C51.3601 99.7579 42.8396 99.5997 34.4962 97.4541C32.0021 96.8142 29.5259 96.0922 27.106 95.2265C13.6458 90.4097 6.08279 80.3578 2.74203 66.9318C-0.393956 54.3302 0.34632 41.7758 6.5054 30.2584C15.4638 13.506 29.3714 2.66013 48.6107 1.10329C65.9229 -0.297333 80.4005 6.38839 91.0896 20.4813C95.0735 25.7313 97.7973 31.586 99.7952 38.28ZM64.0904 89.6424C68.4656 89.4652 72.8447 89.3602 77.2172 89.0976C91.7833 88.2227 106.34 87.1398 120.914 86.4578C126.295 86.196 131.546 84.7107 136.266 82.1149C144.544 77.6898 148.643 70.6572 149.115 61.4402C149.64 51.1876 144.168 42.832 134.92 40.3182C124.32 37.4362 114.41 39.0058 105.855 46.2958C103.303 48.4702 101.11 51.0627 98.7248 53.436C97.9883 54.2735 97.1423 55.0072 96.2084 55.6165C93.8134 56.9377 91.2117 55.9444 90.0427 53.4693C89.7316 52.8114 89.5642 52.0952 89.5511 51.3676C89.538 50.6401 89.6791 49.918 89.9659 49.2493C91.3226 45.5941 90.8001 41.9864 89.5833 38.3877C87.7843 33.3024 85.0887 28.5807 81.6232 24.4469C70.8186 11.0891 49.5211 6.84961 34.892 15.0472C14.4051 26.5332 6.8663 44.8707 11.9371 65.9641C14.3446 75.9834 20.2726 83.2621 30.438 86.4231C33.5393 87.3853 36.6986 88.1499 39.8966 88.7117C47.9085 90.1248 56.0017 89.8505 64.0897 89.6417L64.0904 89.6424Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="159.49" height="99.107" fill={color} transform="translate(0.791504 0.904297)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

VectorIcon.displayName = 'VectorIcon'
